import React from 'react';
import './Syles/Forward.scss';
import StyledTitle from '../../Shared/StyledTitle/StyledTitle';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import {AiOutlineClose} from 'react-icons/ai';
import Styledlink from '../../Shared/StyledLink/StyledLink';
import profile from '../../../Assets/Cards/profile1.png';
import {ImReply} from 'react-icons/im';
import {FaCircle} from 'react-icons/fa';
import {ReactComponent as Number} from '../../../Assets/Icons/number.svg';
const Forward=(props)=>{
    return(
        <div  className={`forward-home ${props.styles}`}>
            <div className="main-part">
                <div className="content">
                    <h1>{props.title}</h1>
                    <p>{props.desc}</p>
                    {props.desc1 ?    <p>{props.desc1}</p> : null}
                    <StyledButton btn="Learn More" styles="nobg-btn"/>
                </div>
                <div className="image-part">
                    <div className="testimonial" data-aos="zoom-in"
              data-aos-delay={200}>
                  <Number className="number"/>
                        <div className="name">
                         <img src={profile} />
                         <h3>John Petla</h3>
                        </div>
                        <p>we need more work here. Please add some images here.</p>
                         <div className="post">
                             <p>Just Now</p>
                             <p><FaCircle className="icon"/> Mark as done</p>
                             <p><ImReply className="icon" /> Reply</p>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
export default Forward ;